// extracted by mini-css-extract-plugin
module.exports = {"truck_slide_item":"_1X4Sr","truck_slide_item_image":"_3EQMa","black":"_2g9aI"};